module.exports = __webpack_public_path__ + "img/about_logo_23.83c8113c.png";